import { Button } from '../../../../..'
import { PhoneSvg, LetterSvg } from '../../../../../../svgs'
import { defineMessages, useIntl } from 'react-intl'

import styles from './AgentContactButton.module.scss'

export const MSG = defineMessages({
  call: {
    id: 'AgentCard.call',
    defaultMessage: 'Call',
  },
  email: {
    id: 'AgentCard.email',
    defaultMessage: 'Email',
  },
})

export interface AgentContactButtonProps {
  contact: string | number
  isPhone: boolean
}

export const AgentContactButton = ({
  isPhone,
  contact,
}: AgentContactButtonProps) => {
  const intl = useIntl()

  return (
    <Button
      href={isPhone ? `tel:${contact}` : `mailto:${contact}`}
      iconStart={isPhone ? PhoneSvg : LetterSvg}
      className={styles.contactBtn}
      data-text={contact}
      element='a'
      fullWidth
    >
      {isPhone ? intl.formatMessage(MSG.call) : intl.formatMessage(MSG.email)}
    </Button>
  )
}
